export enum CoordinatesType{
    StartX,
    StartY,
    Width,
    Height
}